export default __webpack_public_path__ + "static/media/sprint.350fde3a.png";